import { createGlobalStyle } from "styled-components";
import { breakpoint } from "@utilities";

export const GlobalStyles = createGlobalStyle`
    body, html {
        font-family: ${(props) => props.theme.fonts.primary};
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    * {
        box-sizing: inherit;
    }
    
    .MuiList-padding {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .MuiPickersDatePickerRoot-toolbar.MuiPickersToolbar-toolbar {
        background-color: ${(props) => props.theme.colors.main} !important;
    }

    .MuiButtonBase-root.MuiIconButton-root.MuiPickersDay-day.MuiPickersDay-daySelected {
        background-color: ${(props) => props.theme.colors.main} !important;
    }

    /*
     * Focused form fields, everywhere.
     *
     * The MUI theme in App.tsx sets primary to the brand colour, which is the
     * right configuration, but it does not reach every case on its own: emotion
     * and styled-components inject independently, and several of these inputs are
     * wrapped in styled(InputLabel)/styled(Input), so which rule wins varies by
     * form. Stated globally here so a dozen forms do not each need their own
     * override, and marked important because MUI's own rule carries equal
     * specificity.
     */
    .MuiFormLabel-root.Mui-focused,
    .MuiInputLabel-root.Mui-focused {
        color: ${(props) => props.theme.colors.main} !important;
    }

    .MuiInput-root:after,
    .MuiInput-underline:after,
    .MuiFilledInput-root:after {
        border-bottom-color: ${(props) => props.theme.colors.main} !important;
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) => props.theme.colors.main} !important;
    }

    /*
     * Third-party chat launcher, raised off the bottom of the phone screen.
     *
     * The widget is injected from outside this app and anchors itself bottom-right,
     * knowing nothing about what it lands on. Its container is a react-draggable
     * div, so it also carries an inline \`transform\` once someone moves it — that
     * translation is relative to wherever these rules put it, so the two do not
     * fight. Important throughout because the widget sets its own position.
     *
     * Two heights: a lift on every mobile page so the button clears the very edge
     * of the screen, and a larger one on the pages carrying the 60px fixed bottom
     * bar, where it would otherwise cover the Quotes and Account tabs.
     * FooterModule sets the body class while that bar is on screen.
     */
    ${breakpoint.breakOnlyMobile`
        .livesdk__Draggable {
            bottom: 30px !important;
        }
    `}

    body.has-bottom-bar .livesdk__Draggable {
        bottom: 90px !important;
    }
`;
